import { createFileRoute } from "@tanstack/react-router";
import Component from "./-components/component";
import { httpClient } from "@/httpClient";
import getPharmacyID from "@/utils/pharmacy_code";
import { Supplier } from "@/gen/suppliers/common_pb";
import { pharmacyClient } from "@/connect";
import { RequestStatus } from "@/gen/purchase_request/common_pb";
import { ListPurchaseRequestsResponse } from "@/gen/purchase_request/list_purchase_requests_pb";
import { StockPointType } from "@/gen/auth/common_pb";
import { PharmacySize } from "@/gen/auth/common_pb";
export const Route = createFileRoute("/(pharma)/_layout/inventory/create-purchase-order/")({
    component: Component,
    loader: async (): Promise<{
        suppliers: Supplier[];
        purchaseRequests: ListPurchaseRequestsResponse
        stockPointId?: string;
    }> => {
        let stockPointId = undefined
        if (PharmacySize.SIZE_SMALL.toString() === localStorage.getItem('pharmacySize')) {
            const stockPoints = await pharmacyClient.getStockPoints({})
            for (const sp of stockPoints.stockPoints) {
            if (sp.stockPointType === StockPointType.RECEIVING) {
                stockPointId = sp.id
                break
            }
            }
        }
        const suppliers = await pharmacyClient.listSuppliers({
            page: 1,
            pageSize: 1000,
        })
        const purchaseRequests = await pharmacyClient.listPurchaseRequests({
            page: 1,
            pageSize: 1000,
            requestStatus: RequestStatus.PENDING,
        })
        return {
            suppliers: suppliers.suppliers as Supplier[],
            purchaseRequests: purchaseRequests,
            stockPointId,
        }
    }
})